// extracted by mini-css-extract-plugin
module.exports = {"list":"ListPreview_list__1z_4y","listPreview":"ListPreview_listPreview__9cNkd","theme-for-table":"ListPreview_theme-for-table__2j85Q"};